<template>
  <template v-if="getUser">
    <div class="mb-3 bg-white info-panel rounded">
      <div class="hover-scroll-x">
        <div class="d-grid">
          <ul class="nav nav-tabs nav-line-tabs fs-6 ps-5 pe-5 pt-3 flex-nowrap text-nowrap">
            <li class="nav-item me-auto">
              <a v-if="roleSales.includes(this.$user.role)"  @click="getBranches" class="nav-link pb-3 active" data-bs-toggle="tab" href="#branches">Орг.Структура</a>
            </li>
            <template v-if="roleModerator.includes(this.$user.role) || roleAccountant.includes(this.$user.role)">
              <li v-if="roleAdmin.includes(this.$user.role)" class="nav-item">
                <a @click="getDepartments" class="nav-link pb-3" data-bs-toggle="tab" href="#departments">Филиалы</a>
              </li>
              <li class="nav-item">
                <a @click="getUsers" class="nav-link pb-3" :class="{'active': !roleAdmin.includes(this.$user.role)}" data-bs-toggle="tab" href="#employees">Сотрудники</a>
              </li>
              <li  class="nav-item float-end">
                <a @click="getSignatoriesRequest" class="nav-link pb-3" data-bs-toggle="tab" href="#signatories">Подписанты</a>
              </li>
              <li class="nav-item float-end">
                <a @click="getTerminalsRequest" class="nav-link pb-3" data-bs-toggle="tab" href="#terminal">Терминалы (Касса)</a>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div v-if="roleSales.includes(this.$user.role)" class="tab-pane show active" id="branches" role="tabpanel">
          <div class="table-responsive">
            <div class="p-5">
              <ul v-if="!branchLoaded" class="employees__list main fs-6">
                <branch-item v-if="branches && branches.length" :open="true" :model="branches[0]"></branch-item>
                <span v-else class="py-15 text-center d-flex justify-content-center bg-light-danger fw-bold">
                  <span class="text-danger">Вы не прикреплены к Департаменту/Менеджеру. <br> Обратитесь техподдержку</span>
                </span>
              </ul>
              <loader-full class="h-200px" text="Загрузка Орг.Структуры" v-else/>
            </div>
          </div>
        </div>
        <template v-if="roleModerator.includes(this.$user.role) || roleAccountant.includes(this.$user.role)">
          <div v-if="roleAdmin.includes(this.$user.role)" class="tab-pane" id="departments" role="tabpanel">
            <branch-departments-table v-if="!departmentsLoaded" :departments="departments" :filter="filter.departments" @reloaded="reloadDepartments"/>
            <loader-full v-else/>
          </div>
          <div class="tab-pane" :class="{'show active': !roleAdmin.includes(this.$user.role)}" id="employees" role="tabpanel">
            <branch-employees-table v-if="!employeesLoaded" :employees="users" :filter="filter.users" @reloaded="reloadUsers"/>
            <loader-full v-else/>
          </div>
          <div class="tab-pane" id="signatories" role="tabpanel">
            <branch-signatories-table v-if="!signatoriesLoaded" :signatories="getSignatories" />
            <loader-full v-else/>
          </div>
          <div class="tab-pane" id="terminal" role="tabpanel">
            <branch-terminals-table v-if="!terminalsLoaded" :terminals="getTerminals" />
            <loader-full v-else/>
          </div>
        </template>
      </div>
      <branch-user-create-update-model :page="this.usersPage" @reloaded="getUsers"/>
      <branch-department-create-update-model :page="this.departmentsPage" @reloaded="getDepartments"/>
      <branch-signatory-add-by-one-c-model/>
      <branch-terminal-create-update-model/>
    </div>
  </template>
  <template v-else>
    <loader-full/>
  </template>
</template>

<script>
import axios from 'axios'
//Model
import BranchDepartmentCreateUpdateModel from '@/components/Branch/Modal/BranchDepartmentCreateUpdateModel'
import BranchTerminalCreateUpdateModel   from '@/components/Branch/Modal/BranchTerminalCreateUpdateModel'
import BranchSignatoryAddByOneCModel     from '@/components/Branch/Modal/BranchSignatoryAddByOneCModel'
import BranchUserCreateUpdateModel       from '@/components/Branch/Modal/BranchUserCreateUpdateModel'
// Table
import BranchSignatoriesTable from '@/components/Branch/Table/BranchSignatoriesTable'
import BranchDepartmentsTable from '@/components/Branch/Table/BranchDepartmentsTable'
import BranchTerminalsTable   from '@/components/Branch/Table/BranchTerminalsTable'
import BranchEmployeesTable   from '@/components/Branch/Table/BranchEmployeesTable'
// Other
import BranchItem             from '@/components/Branch/BranchItem'
import LoaderFull             from '@/components/Main/LoaderFull'
import permissions            from "@/helpers/permissions";

export default {
  name: 'Branches',
  components: { BranchDepartmentCreateUpdateModel, BranchDepartmentsTable, BranchTerminalCreateUpdateModel, BranchSignatoryAddByOneCModel,
    BranchUserCreateUpdateModel, BranchSignatoriesTable, BranchEmployeesTable, BranchTerminalsTable, LoaderFull, BranchItem },
  data() {
    return {
      departmentsLoaded: false,
      signatoriesLoaded: false,
      terminalsLoaded:   false,
      employeesLoaded:   false,
      branchLoaded:      false,
      departments: null,
      branches:    null,
      users:       null,
      usersPage:       1,
      departmentsPage: 1,
      filter: {
        users: {
          isDep:  false,
          user:   null,
          type:   null,
          role:   null,
          title:  '',
          iin:    ''
        },
        departments: {
          parent: null,
          head:   null,
          title:  null,
          type:   null,
        }
      }
    }
  },
  mounted() {
    if (this.$user) {
      if (permissions.admin().includes(this.$user.role)) {
        this.getBranches()
      } else {
        this.getUsers()
      }
    } else {
      alert('Данный сотрудника не найдено')
    }
  },
  computed: {
    getSignatories() { return this.$store.getters.getSignatories },
    getTerminals()   { return this.$store.getters.getTerminals },
    getUser()        { return this.$store.state.user },
    roleAdmin()      { return permissions.admin() },
    roleModerator()  { return permissions.moderator() },
    roleSales()      { return permissions.groupSale() },
    roleAccountant() { return permissions.accountant() },
  },
  methods: {
    getBranches() {
      this.branchLoaded = true
      axios.get('/api/branches/index')
          .then(res => {
            if (res.data.length) this.branches = res.data
          })
          .catch(err => {console.log(err)})
          .finally(() => {this.branchLoaded = false})
    },
    getSignatoriesRequest() {
      this.signatoriesLoaded = true
      this.$store.dispatch('signatoriesRequest').finally(() => this.signatoriesLoaded = false)
    },
    getTerminalsRequest() {
      this.terminalsLoaded = true
      this.$store.dispatch('terminalsRequest').finally(() => this.terminalsLoaded = false)
    },
    getUsers(page = 1) {
      this.employeesLoaded = true
      const headers = {headers: {}, params: this.filter.users}
      axios.get('/api/branches/list/employees?page=' + page, headers)
          .then(res  => {
            this.users      = res.data
            this.usersPage  = page
          })
          .catch(err => { console.log(err) })
          .finally(() => {if (this.employeesLoaded) this.employeesLoaded = false})
    },
    getDepartments(page = 1) {
      this.departmentsLoaded = true
      const headers = {headers: {}, params: this.filter.departments}
      axios.get('/api/branches/list/departments?page=' + page, headers)
          .then(res  => {
            this.departments      = res.data
            this.departmentsPage  = page
          })
          .catch(err => { console.log(err) })
          .finally(() => {if (this.departmentsLoaded) this.departmentsLoaded = false})
    },
    reloadUsers(val) {
      if (val) this.getUsers(val)
    },
    reloadDepartments(val) {
      if (val) this.getDepartments(val)
    }
  }
}
</script>

<style scoped>

</style>